// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import i18n from "@/i18n"
import router from "@/router"
import store from "@/store"
import App from "@/App"
import HotHeader from "@/components/HotHeader"
import HotFooter from "@/components/HotFooter"
import {Swiper, SwiperSlide} from "vue-awesome-swiper"
import * as utils from "@/utils"
import * as services from "@/services"
import {marked} from "marked"

import "swiper/css/swiper.css"
import "!style-loader!css-loader!sass-loader!./index.scss"
import "!style-loader!css-loader!sass-loader!./assets/index/iconfont.css"
import "!style-loader!css-loader!sass-loader!./assets/download/iconfont.css"

Vue.component("swiper", Swiper)
Vue.component("swiper-slide", SwiperSlide)
Vue.component(HotHeader.name, HotHeader)
Vue.component(HotFooter.name, HotFooter)

Vue.config.productionTip = false

//导入公共函数
Vue.prototype.$utils = utils
Vue.prototype.$services = services
Vue.prototype.$getLanguage = () => i18n.locale || localStorage.getItem("language") || "zh"
Vue.prototype.$setLanguage = lang => i18n.locale = lang
Vue.prototype.$marked = marked

//基于smoke.js
Vue.prototype.$alert = function(message) {
  smoke.alert(message, function(e) {
  }, {ok: i18n.t("ok")})
}

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js